// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7921ce6","952":"e01e6645"}[chunkId] + ".chunk.js";
};